import * as React from 'react';

const ArrowLeftIcon = (props: any): React.ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M14.435 18L8.66101 12L14.435 6"
      stroke="#2B8FD7"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowLeftIcon;
